export const SET_METADATA_HEADERS = 'SET_METADATA_HEADERS'
export const SET_CLASSIFICATION_DATA = 'SET_CLASSIFICATION_DATA'
export const SET_CLASSIFICATION_HIERARCHY = 'SET_CLASSIFICATION_HIERARCHY'
export const SET_CLASSIFICATION_SELECTION = 'SET_CLASSIFICATION_SELECTION'
export const RESET_ASSETTYPE_SELECTION = 'RESET_ASSETTYPE_SELECTION'
